module.exports = "<div class=\"_automations-view\">\n\n  <cm-table-automations></cm-table-automations>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/automationsView/automationsView.vue
// module id = 380
// module chunks = 0